import { X, BookOpen } from "lucide-react";
import { REFERENCES } from "../lib/references";

export function ReferencesModal({ testId, onClose }) {
  const ref = REFERENCES[testId];
  if (!ref) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-[#1E293B]/50 p-4 sm:p-8" onClick={onClose}>
      <div className="w-full max-w-2xl rounded-2xl bg-white p-6 sm:p-8" onClick={(e) => e.stopPropagation()} data-testid="references-modal">
        <div className="mb-4 flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#2563EB]">
              <BookOpen className="h-4 w-4" strokeWidth={1.5} /> References
            </div>
            <h2 className="mt-1 font-display text-2xl text-[#1E293B]">{ref.title}</h2>
            <p className="text-sm text-[#1E293B]/60">References used to develop this questionnaire</p>
          </div>
          <button onClick={onClose} data-testid="close-references-btn" className="rounded-full p-2 text-[#1E293B]/60 hover:bg-[#F1F5F9]"><X className="h-5 w-5" /></button>
        </div>
        <ol className="space-y-3">
          {ref.items.map((r, i) => (
            <li key={i} className="flex gap-3 text-sm leading-relaxed text-[#1E293B]/80">
              <span className="shrink-0 font-semibold text-[#2563EB]">{i + 1}.</span>
              <span>{r}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
